import { Icon } from '../icons/Icon';
import { cn, severityStyle } from '../../utils';
import type { ValidationIssue } from '../../types';
import { ErrorEntry } from './ErrorEntry';

export interface ErrorSummaryProps {
  issues: ValidationIssue[];
  className?: string;
}

/** Vertical list of validation issues — one per row, each prefixed by the
 * per-severity icon. Renders nothing when `issues` is empty. */
export function ErrorSummary({ issues, className }: ErrorSummaryProps) {
  if (!issues.length) return null;
  return (
    <ul className={cn('flex flex-col gap-2xs', className)}>
      {issues.map((issue, i) => {
        const sev = severityStyle(issue.severity);
        return (
          <li
            key={`${issue.path}|${issue.code}|${i}`}
            className={cn('flex items-start gap-xs text-xs', sev?.iconColor)}
          >
            {sev && <Icon name={sev.icon} className='w-3.5 h-3.5 mt-2xs shrink-0' />}
            <ErrorEntry showActual={true} issue={issue} />
          </li>
        );
      })}
    </ul>
  );
}
